import React, { useEffect, useState,useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';


const ApproveSalaryModal = ({ isVisible,employee, onApprove, onReject }) => {
  const [salaryDetails, setSalaryDetails] = useState(null); // State to hold salary details
  const [isLoading, setIsLoading] = useState(false); // State to manage loading state
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const submitButtonRef = useRef(null);


  useEffect(() => {
    if (employee && employee.id) {
            setIsLoading(true); // Start loading
      const fetchPendingSalary = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/payroll/pending-salary/${employee.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setSalaryDetails(response.data.data); // Set the fetched salary details
        } catch (error) {
          console.error("Error fetching pending salary:", error);
          toast.error("Failed to fetch pending salary details.");
        } finally {
          setIsLoading(false); // Stop loading
        }
      };

      fetchPendingSalary();
    } else {
      setSalaryDetails(null); // Reset salary details if employee is null
    }
  }, [employee]);


  const handleApprove = async () => {
    try {
      // Show a confirmation dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `You are about to approve the salary revision for ${salaryDetails?.employee_name || "the employee"}. This action cannot be undone.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Approve!',
        cancelButtonText: 'Cancel',
      });
  
      // If user confirms the action
      if (result.isConfirmed) {
        // Call the approve salary API
        const response = await axios.post(
          `${apiUrl}/payroll/approve-salary`,
          { 
            revision_id: salaryDetails?.id, // Pass the revision_id
            employee_id: salaryDetails?.employee_id, // Pass the employee ID (empid)
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        // Show success toast
        toast.success(response.data.message || "Salary approved successfully!");
  
        // Refresh the parent state
        if (onApprove) {
          onApprove();
        }
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Trigger the click event
        }

      }
    } catch (error) {
      console.error("Error approving salary:", error);
      toast.error("Failed to approve salary. Please try again.");
    }
  };
  


  const handleReject = () => {
    const rejectionComments = prompt("Enter rejection comments:"); // Prompt for comments
    if (onReject && salaryDetails) {
      onReject(salaryDetails.id, rejectionComments,salaryDetails?.employee_id); // Use the salary revision ID
    
      if (submitButtonRef.current) {
        submitButtonRef.current.click(); // Trigger the click event
      }
    
    }


  };

  if (!employee) {
    return null; // Do not render if no employee is selected
  }

  return (
<div id="approve_salary" className="modal custom-modal fade" role="dialog">
  <div
          className="modal-dialog modal-lg"
          style={{
            margin: 0,
            position: "fixed",
            right: 0,
            height: "100vh",
            width: "100%",
          }}
          role="document"
        >
          <div className="modal-content h-100">
          <div className="modal-header">
        <h5 className="modal-title">Approve Salary</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div className="modal-body">
        {isLoading ? (
          <p>Loading salary details...</p>
        ) : salaryDetails ? (
          <>
            {/* Employee Information */}
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="col-md-12">
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "10px",
      background: "#f9f9f9",
    }}
  >
    <div style={{ flex: "1 1 25%", marginBottom: "10px" }}>
      <strong>Name:</strong> {employee.name || "N/A"}
    </div>
    <div style={{ flex: "1 1 25%", marginBottom: "10px" }}>
      <strong>Employee ID:</strong> {employee.empcode || "N/A"}
    </div>
    <div style={{ flex: "1 1 25%", marginBottom: "10px" }}>
      <strong>Department:</strong> {employee.department_name || "N/A"}
    </div>
    <div style={{ flex: "1 1 25%", marginBottom: "10px" }}>
      <strong>Date of Joining:</strong>{" "}
      {employee.date_of_joining
        ? employee.date_of_joining.format("MMM DD, YYYY")
        : "N/A"}
    </div>
  </div>
</div>

              </div>
              
            </div>

            {/* Salary Breakdown Table */}
         {/* Salary Breakdown Table */}
<table
  style={{
    width: "100%",
    border: "1px solid #000",
    borderCollapse: "collapse",
    textAlign: "left",
    marginTop: "20px",
  }}
>
  <thead>
    <tr style={{ background: "#f0f0f0" }}>
      <th style={{ border: "1px solid #000", padding: "5px", width: "40%" }}>Earnings</th>
      <th style={{ border: "1px solid #000", padding: "5px", width: "20%" }}>Amount</th>
      <th style={{ border: "1px solid #000", padding: "5px", width: "40%" }}>Deductions</th>
      <th style={{ border: "1px solid #000", padding: "5px", width: "20%" }}>Amount</th>
    </tr>
  </thead>
  <tbody>
    {salaryDetails.salary_breakdown?.earnings.map((earning, index) => (
      <tr key={`earning-${index}`}>
        <td style={{ border: "1px solid #000", padding: "5px" }}>{earning.head}</td>
        <td style={{ border: "1px solid #000", padding: "5px" }}>₹{parseFloat(earning.amount || 0).toFixed(2)}</td>
        {index < salaryDetails.salary_breakdown?.deductions.length ? (
          <>
            <td style={{ border: "1px solid #000", padding: "5px" }}>
              {salaryDetails.salary_breakdown.deductions[index]?.head}
            </td>
            <td style={{ border: "1px solid #000", padding: "5px" }}>
              ₹{parseFloat(salaryDetails.salary_breakdown.deductions[index]?.amount || 0).toFixed(2)}
            </td>
          </>
        ) : (
          <>
            <td style={{ border: "1px solid #000", padding: "5px" }}></td>
            <td style={{ border: "1px solid #000", padding: "5px" }}></td>
          </>
        )}
      </tr>
    ))}
    {salaryDetails.salary_breakdown?.deductions
      .slice(salaryDetails.salary_breakdown?.earnings.length)
      .map((deduction, index) => (
        <tr key={`deduction-extra-${index}`}>
          <td style={{ border: "1px solid #000", padding: "5px" }}></td>
          <td style={{ border: "1px solid #000", padding: "5px" }}></td>
          <td style={{ border: "1px solid #000", padding: "5px" }}>{deduction.head}</td>
          <td style={{ border: "1px solid #000", padding: "5px" }}>
            ₹{parseFloat(deduction.amount || 0).toFixed(2)}
          </td>
        </tr>
      ))}
  </tbody>
  <tfoot>
    <tr style={{ background: "#f9f9f9", fontWeight: "bold" }}>
      <td style={{ border: "1px solid #000", padding: "5px" }}>Total Earnings</td>
      <td style={{ border: "1px solid #000", padding: "5px" }}>
        ₹{parseFloat(salaryDetails.gross_salary || 0).toFixed(2)}
      </td>
      <td style={{ border: "1px solid #000", padding: "5px" }}>Total Deductions</td>
      <td style={{ border: "1px solid #000", padding: "5px" }}>
        ₹{parseFloat(salaryDetails.deductions || 0).toFixed(2)}
      </td>
    </tr>
    <tr style={{ background: "#e0e0e0", fontWeight: "bold" }}>
      <td style={{ border: "1px solid #000", padding: "5px" }} colSpan="3">
        Net Pay
      </td>
      <td style={{ border: "1px solid #000", padding: "5px" }}>
        ₹{parseFloat(salaryDetails.net_salary || 0).toFixed(2)}
      </td>
    </tr>
  </tfoot>
</table>

          </>
        ) : (
          <p>No salary details available.</p>
        )}
      </div>
      <div className="modal-footer">
        <button
          className="btn btn-success"
          onClick={handleApprove}
          disabled={!salaryDetails}
        >
          Approve
        </button>
        <button
          className="btn btn-danger"
          onClick={handleReject}
          disabled={!salaryDetails}
        >
          Reject
        </button>
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>

          <div style={{ display: "none" }}>
        <button
          ref={submitButtonRef}
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
        >
          Submit2
        </button>
      </div>
      </div>
    </div>
  </div>
</div>



  );
};

export default ApproveSalaryModal;
